import { useEffect } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export function useSessionHeartbeat(logoutCallback, intervalMs = 300000, token) {
  useEffect(() => {
    if (!token) return; // Only run heartbeat if token exists

    let timer = null;
    let active = true;

    async function pingBackend() {
      try {
        await axios.get(`${API_BASE_URL}/api/ping`, {
          headers: {
            Authorization: "Bearer " + token
          }
        });
      } catch (e) {
        if (e.response && (e.response.status === 401 || e.response.status === 403)) {
          if (active) logoutCallback();
        }
      }
    }

    timer = setInterval(pingBackend, intervalMs);
    pingBackend();

    return () => {
      active = false;
      if (timer) clearInterval(timer);
    };
  }, [logoutCallback, intervalMs, token]);
}
